export const SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS = 500;
export const EXPERIMENT_NAME_CHAR_LIMIT = 255;
export const NA = 'N/A';
